'use client'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './style.css'
import { ReactNode, useState, RefObject, useEffect, useMemo } from 'react'
import React from 'react'

type Props = {
  children: ReactNode
  slidesToShow?: number
  arrows?: boolean
  sliderRef?: RefObject<InstanceType<typeof Slider>>
  infinite?: boolean
  dotCenter?: boolean
  dotWidth?: string
  showDots?: boolean
}

const Carousel = ({
  children,
  slidesToShow: desktopSlides = 3,
  arrows = false,
  infinite = true,
  sliderRef,
  dotCenter = true,
  dotWidth,
  showDots = true,
}: Props) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [width, setWidth] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 1200)

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const dynamicSlidesToShow = useMemo(() => {
    if (width < 768) return 1    
    if (width < 1250) return 2     
    return desktopSlides          
  }, [width, desktopSlides])

  const sliderSettings = {
    dots: false,
    speed: 1000,
    slidesToShow: dynamicSlidesToShow,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows,
    autoplay: true,
    infinite,
    autoplaySpeed: 5000,
    afterChange: (index: number) => setCurrentSlide(index),
  }

  const childArray = React.Children.toArray(children)
  
  const dotClickHandler = (index: number) => {
    setCurrentSlide(index)
    sliderRef?.current?.slickGoTo(index)
  }

  return (
    <>
      <Slider ref={sliderRef} {...sliderSettings}>
        {childArray}
      </Slider>

      {showDots && (
        <div className={`relative ${dotCenter ? 'flex justify-center mt-4' : ''}`}>
          {childArray.map((_, index) => (
            <button
              key={index}
              className={`shadow-lg ${
                dotWidth ?? 'h-3 w-3'
              } rounded-full mx-1 focus:outline-none transition-all duration-300 ${
                currentSlide === index
                  ? 'bg-gray-900 dark:bg-white scale-125'
                  : 'bg-gray-600/30 dark:bg-gray-600/30'
              }`}
              onClick={() => dotClickHandler(index)}
            ></button>
          ))}
        </div>
      )}
    </>
  )
}

export default Carousel